const swiperReview = new Swiper('.review-slider__contents', {
  loop: true,
  slidesPerView: 1,
  spaceBetween: 0,
  pagination: {
    el: '.review-pagination',
    clickable: true,
  },
  navigation: {
    nextEl: `.swiper-button-next-review`,
    prevEl: `.swiper-button-prev-review`,
    enabled: true,
  },
  centeredSlides: true,
  breakpoints: {
    580: {
      slidesPerView: 2,
      centeredSlides: false,
      spaceBetween: 12,
    },
    980: {
      slidesPerView: 4,
      spaceBetween: 12,
      centeredSlides: false,
    }
  }
});
